import { AtividadeColetivaGrupoDetalhesQuery, AtividadeColetivaGrupoSelectQuery } from 'graphql/types.generated'
import { emptyArrayOf, partition } from 'util/array'

import { convertEquipesEnvolvidas } from '../../grupos/converter-atividadeColetivaGrupos'
import {
  AtividadeColetivaGrupoCabecalho,
  AtividadeColetivaGrupoComIntegrantesModel,
  AtividadeColetivaGrupoItemModel,
  AtividadeColetivaGrupoSelectItemModel,
  AtividadeColetivaGrupoSemResultados,
} from './model-atividadeColetivaGrupoSelectField'

type GrupoSelectContent = AtividadeColetivaGrupoSelectQuery['gruposParticipantesAtividadeColetiva']['content'][0]

export const convertToAtividadeColetivaGrupoSelectFieldModel = (
  queryData: AtividadeColetivaGrupoSelectQuery,
  profissionalLogadoId: ID
): AtividadeColetivaGrupoSelectItemModel[] => {
  const items: AtividadeColetivaGrupoSelectItemModel[] = []
  const data = queryData?.gruposParticipantesAtividadeColetiva?.content || emptyArrayOf<GrupoSelectContent>()

  const groupPartitionPredicate = (grupo: GrupoSelectContent) => {
    return grupo?.lotacoesEnvolvidas?.some((lotacao) => lotacao?.profissional?.id === profissionalLogadoId)
  }

  const [meusGrupos, outrosGrupos] = partition(data, groupPartitionPredicate).map((group) => {
    return group.isEmpty()
      ? [AtividadeColetivaGrupoSemResultados.SEM_RESULTADOS_ENCONTRADOS]
      : group.map(convertItemModelToSelectModel)
  })

  items.push(AtividadeColetivaGrupoCabecalho.MEUS_GRUPOS)
  items.push(...meusGrupos)
  items.push(AtividadeColetivaGrupoCabecalho.OUTROS_GRUPOS)
  items.push(...outrosGrupos)

  return items
}

const convertItemModelToSelectModel = (grupo: GrupoSelectContent): AtividadeColetivaGrupoItemModel => {
  const id = grupo.id
  const nome = grupo.nome
  const equipesEnvolvidas = convertEquipesEnvolvidas(grupo.lotacoesEnvolvidas)
  const unidadeDeSaude = grupo.unidadeSaude?.nome || ''

  return {
    id,
    nome,
    equipesEnvolvidas,
    unidadeDeSaude,
  }
}

export const convertToAtividadeColetivaGrupoComIntegrantesModel = (
  grupo: AtividadeColetivaGrupoItemModel,
  queryData: AtividadeColetivaGrupoDetalhesQuery | undefined
): AtividadeColetivaGrupoComIntegrantesModel => ({
  ...grupo,
  cidadaos: queryData?.grupoParticipanteAtividadeColetiva?.cidadaosParticipantes ?? [],
  lotacoes: queryData?.grupoParticipanteAtividadeColetiva?.lotacoesEnvolvidas ?? [],
})
